var COLUMN_NAME_REQUIRED = 'Column name is required.';
var COLUMN_NAME_DUPLICATE = 'Column name already exists.';

function normalizedColumnName(column) {
  if (!column || column.name === undefined || column.name === null) return '';
  return String(column.name).trim();
}

function normalizedColumnKey(column) {
  return normalizedColumnName(column).toLowerCase();
}

function hasDuplicateColumnName(column, columns, currentIndex) {
  var columnKey = normalizedColumnKey(column);
  if (!columnKey) return false;

  return (Array.isArray(columns) ? columns : []).some(function (candidateColumn, candidateIndex) {
    if (currentIndex !== undefined && currentIndex !== null && candidateIndex === currentIndex) {
      return false;
    }
    return normalizedColumnKey(candidateColumn) === columnKey;
  });
}

function validateColumnName(column, columns, currentIndex) {
  if (!normalizedColumnName(column)) return [COLUMN_NAME_REQUIRED];
  if (hasDuplicateColumnName(column, columns, currentIndex)) return [COLUMN_NAME_DUPLICATE];
  return [];
}

function applyNormalizedColumnName(column) {
  if (!column) return;
  column.name = normalizedColumnName(column);
}

module.exports = {
  COLUMN_NAME_DUPLICATE: COLUMN_NAME_DUPLICATE,
  COLUMN_NAME_REQUIRED: COLUMN_NAME_REQUIRED,
  applyNormalizedColumnName: applyNormalizedColumnName,
  normalizedColumnName: normalizedColumnName,
  validateColumnName: validateColumnName
};
